import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  toggle() {
    const isOpen = this.menuTarget.classList.toggle("is-open")
    this.element.querySelector(".site-header__burger").setAttribute("aria-expanded", isOpen)
    document.body.classList.toggle("nav-open", isOpen)
  }

  disconnect() {
    document.body.classList.remove("nav-open")
  }
}
